export interface HereAutosuggestItem {
  title: string;
  id: string;
  address: {
    label: string;
    countryName?: string;
    state?: string;
    city?: string;
    street?: string;
    postalCode?: string;
    houseNumber?: string;
  };
  position?: { lat: number; lng: number };
}

export interface AddressFormState {
  streetAddress: string;
  streetAddress2?: string | null;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  coordinates?: {
    latitude: number;
    longitude: number;
  };
}

export const stringifyAddress = (address: AddressFormState) => {
  const street = address.streetAddress2
    ? `${address.streetAddress}, ${address.streetAddress2}`
    : address.streetAddress;
  const parts = [
    street,
    address.city,
    address.state,
    address.postalCode,
    address.country,
  ].filter(Boolean);
  return parts.join(', ');
};

export const toAddressFormState = (
  item: HereAutosuggestItem,
): AddressFormState => {
  const { address, position } = item;

  return {
    streetAddress: [address.houseNumber, address.street]
      .filter(Boolean)
      .join(' '),
    city: address.city ?? '',
    state: address.state ?? '',
    postalCode: address.postalCode ?? '',
    country: address.countryName ?? '',
    coordinates: position
      ? { latitude: position.lat, longitude: position.lng }
      : undefined,
  };
};
